import { defineMessages } from 'react-intl';

export default defineMessages({
  overlayTitle: {
    id: 'policyOverlay.overlayTitle',
    defaultMessage: 'Cancellation policy',
  },
  cancellationTitle: {
    id: 'policyOverlay.cancellationTitle',
    defaultMessage: 'Cancelling this experience',
  },
  understand: {
    id: 'policyOverlay.understand',
    defaultMessage: 'I understand',
  },
});
